// Features the API blocks unless the plan explicitly turns them on
// (enforceFeature in api-node). A missing key means "not included", so the UI
// must lock them too — otherwise the pages open and every call fails with 403.
const ENFORCED_FEATURES = new Set([
  'monitoring',
  'security',
  'server_monitoring',
  'endpoint_management',
  'email_monitoring',
  'seo',
  'seo_ai',
]);

export const isPlanFeatureLocked = (features: Record<string, boolean>, feature?: string): boolean => {
  if (!feature || !Object.keys(features).length) return false; // plan not loaded
  return ENFORCED_FEATURES.has(feature) ? features[feature] !== true : features[feature] === false;
};
